// extracted by mini-css-extract-plugin
export var closeButton = "_ko-1";
export var closeX = "_ko-3";
export var container = "_ko-0";
export var image = "_ko-2";